import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useState } from "react";

const NavbarSrc = (props) => {
    const navigate = useNavigate();
    let [authState, setAuthState] = useState(false);

    authState = props.value;

    const logOut = () =>{
        sessionStorage.removeItem("userName");
        sessionStorage.removeItem("accessToken");
        sessionStorage.removeItem("refreshToken");
        setAuthState(false);      
        navigate('/');
    }

    return (
        <div>
            <Navbar bg="dark" variant="dark">
                <Container>
                    <Navbar.Brand href="/"><img style={{width: "200px", borderRadius: "5px"}} src='/coexca.gif'></img></Navbar.Brand>
                    <Nav className="me-auto">
                        {authState && (<>
                            <Nav.Link href="/">Recepciones</Nav.Link>
                        </>)}
                    </Nav>
                    
                    <Navbar.Collapse className="justify-content-end">
                        <Nav>
                            {!authState && (<>
                                <Button variant="secondary" href={"/"} onClick={()=> navigate('/Login')}>Ingresar</Button>{' '}
                            </>)}
                            {authState && (<>
                            <Navbar.Text>
                                <Button variant="secondary" onClick={logOut} href={"/"}>
                                    Desconectarse: {sessionStorage.getItem("userName")}
                                </Button>{' '}
                            </Navbar.Text>
                            </>)}
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </div>
    )
}

export default NavbarSrc
